import { render, staticRenderFns } from "./email-text.vue?vue&type=template&id=7fac2d36&scoped=true&"
import script from "./email-text.vue?vue&type=script&lang=js&"
export * from "./email-text.vue?vue&type=script&lang=js&"
import style0 from "./email-text.vue?vue&type=style&index=0&id=7fac2d36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fac2d36",
  null
  
)

export default component.exports